import { Save } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Button,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Field, Form, Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { color } from "../../../../StyleData/Config";
import { axiosPrivate } from "../../../../axios/axios";
import { masterAPI } from "../../../Masters/dataConfig";
import { toast } from "react-toastify";
import { defaultInfo, SubMenu, woStatus } from "../../../../ConfigInfo/Info";
import ResponsiveDialog from "../../../../Component/ResponsiveDialog";

const workflowStatuses = [woStatus.PENAPP, woStatus.APPR, woStatus.PAPPR];
const closeflowStatuses = [woStatus.PAPPRCLOSE, woStatus.APPRCLOSE];
const partReservationflowStatuses = [woStatus.PPRAPPR, woStatus.RFE, woStatus.PRREJT];

const ChangeStatusWO = ({ data, getData, enableDisable, actionAllow }) => {
  const trueDisable = !actionAllow?.edit;
  const [selectList, setSelectList] = useState([]);
  const [meterResetInfo, setMeterResetInfo] = useState(null);
  const [resetSubmitStatusValues, setResetSubmitStatusValues] = useState(null);
  const [resetMeterValue, setResetMeterValue] = useState(0);
  const [openResetMeterDialog, setOpenResetMeterDialog] = useState(false);
  const subMenuList = useSelector((state) => state.dataRed.subMenuList);
  const closeSubMenu = subMenuList.find((fil) => fil.id === SubMenu.workOrderClose);
  const canEditClose = Boolean(closeSubMenu?.edit);
  const disabledStatuses = [
    ...(data.isworkflow ? workflowStatuses : []),
    ...(data.isCloseWorkflow ? closeflowStatuses : []),
    ...(data.isPartWorkflow ? partReservationflowStatuses : []),
    ...(canEditClose ? [] : [woStatus.CLOSE]),
  ];
  const currentStatus = data.status?.toUpperCase();
  const allowEditStatuses = [woStatus.STOP, woStatus.APPR, woStatus.RFE, woStatus.APPRCLOSE];
  const isWorkflowLocked =
    !allowEditStatuses.includes(currentStatus) &&
    ((data.isworkflow && workflowStatuses.includes(currentStatus)) ||
      (data.isCloseWorkflow && closeflowStatuses.includes(currentStatus)) ||
      (data.isPartWorkflow && partReservationflowStatuses.includes(currentStatus)));
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    getDataList();
    getData();
  }, []);

  const getDataList = async () => {
    const selectLink = masterAPI["selectList"].woStatus;
    await axiosPrivate
      .get(`${selectLink}`)
      .then((res) => {
        console.log(res.data);
        setSelectList(res.data);
      })
      .catch((e) => {
        setSelectList([]);
        console.log(e, "changeStatusAsset");
      });
  };

  const saveStatus = async (value) => {
    
    const changeLink = masterAPI["workOrder"].changeStatus;
    try {
      const res = await axiosPrivate.put(`${changeLink}`, value);
      console.log(res);
      getData();
    } catch (e) {
      console.log(e, "changeStatus update");
    } finally {
      setLoading(false);
      setResetSubmitStatusValues(null);
      setResetMeterValue(0);
      setOpenResetMeterDialog(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      id: data.id,
      code: data.code,
      workOrderName: data.workOrderName,
      status: data.status,
      reasontoCancel: data.reasontoCancel,
    },
    enableReinitialize: true,
    onSubmit: async (value) => {
      setLoading(true);

      if (
        value.status === woStatus.CLOSE
         && (data.workTypeCode === defaultInfo.workType.PDM || data.workTypeCode === defaultInfo.workType.PM)
      ) {
        const meterResetLink = masterAPI["workOrder"].getMeterResetInfo;
        try {
          const res = await axiosPrivate.get(`${meterResetLink}/${data.id}`);
          if (res.data.result) {
            setMeterResetInfo(res.data.result);
            if (
              res.data.result?.isConditionSchedule &&
              res.data.result?.isGaugeMeter &&
              !res.data.result?.resetMeterWhenWorkOrderIsRaised
            ) {
              setOpenResetMeterDialog(true);
              setResetSubmitStatusValues(value);
            }else{
              value.meterResetValue = res.data.result.resetTo;
              saveStatus(value);
            }
          }
        } catch (error) {
          setMeterResetInfo(null);
          console.log(error, "getMeterResetInfo");
        }
      } else {
        saveStatus(value);
      }
    },
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <Box>
        <Typography
          sx={{
            color: color.sideTitleColor,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideWeightFont,
          }}
        >
          Change Status
        </Typography>
      </Box>

      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
          p: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              color: color.sideTitle2Color,
              fontSize: color.fontSizeSide,
              fontWeight: color.sideFontWeight,
            }}
          >
            Details
          </Typography>

          {showConfirm ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography sx={{ color: "green" }}>Are you sure you want to save?</Typography>
              <Button
                onClick={() => {
                  formik.handleSubmit();
                  setShowConfirm(false); // Reset confirmation state
                }}
                sx={{ color: "grey", borderColor: "green" }}
                size="small"
                variant="outlined"
              >
                Yes
              </Button>
              <Button
                onClick={() => setShowConfirm(false)}
                sx={{ color: "grey", borderColor: "red" }}
                size="small"
                variant="outlined"
              >
                No
              </Button>
            </Box>
          ) : (
            <IconButton disabled={trueDisable || loading || isWorkflowLocked} onClick={() => setShowConfirm(true)}>
              {loading ? (
                <CircularProgress size={20} />
              ) : (
                <Save sx={{ color: trueDisable || isWorkflowLocked ? "default" : "#2362B4" }} />
              )}
            </IconButton>
          )}
        </Box>
        <Divider />
        <Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Box>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                WO Code
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="code"
                value={formik.values.code}
                inputProps={{ readOnly: true }}
                placeholder="Enter WO Id"
                // fullWidth
                onChange={formik.handleChange}
                sx={{
                  width: "45%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                WO Name
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="workOrderName"
                value={formik.values.workOrderName}
                inputProps={{ readOnly: true }}
                placeholder="Enter WO Name"
                onChange={formik.handleChange}
                // fullWidth
                sx={{
                  width: "45%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  mb: "0.5rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Status
              </Typography>

              <Select
                // label={"Select"}
                size={"small"}
                type="text"
                name="status"
                variant="standard"
                readOnly={trueDisable || isWorkflowLocked}
                value={formik.values.status}
                onChange={formik.handleChange}
                // fullWidth
                sx={{
                  width: "45%",
                  fontSize: "13px",
                  color: trueDisable || isWorkflowLocked ? color.placeholderColor : "inherit",
                  backgroundColor: trueDisable || isWorkflowLocked ? color.TableCancelButton : "transparent",
                }}
                displayEmpty
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                renderValue={
                  formik.values.status !== ""
                    ? undefined
                    : () => (
                        <Typography
                          sx={{
                            color: color.placeholderColor,
                            fontSize: "13px",
                          }}
                        >
                          Select
                        </Typography>
                      )
                }
              >
                {selectList.map((id, i) => (
                  <MenuItem value={id.value} disabled={disabledStatuses.includes(id.value)}>
                    {id.text}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box sx={{ display: formik.values.status === woStatus.CAN ? "default" : "none" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Feedback
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="reasontoCancel"
                multiline
                minRows={1}
                maxRows={10}
                value={formik.values.reasontoCancel}
                placeholder="Enter Reason"
                onChange={formik.handleChange}
                // fullWidth
                sx={{
                  width: "45%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Paper>
      <ResponsiveDialog
        open={openResetMeterDialog}
        onClose={() => setOpenResetMeterDialog(false)}
        fullWidth
        maxWidth="xs"
        children={
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2.5, sm: 3 },
              borderRadius: 2,
            }}
          >
            <Box sx={{ mb: 2.5 }}>
              <Typography
                variant="h6"
                sx={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "text.primary",
                  mb: 0.75,
                }}
              >
                Reset Meter Reading
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "13px",
                  color: "text.secondary",
                  lineHeight: 1.6,
                }}
              >
                Enter the new reset value for the meter reading.
              </Typography>
            </Box>

            <TextField
              fullWidth
              variant="outlined"
              size="small"
              type="number"
              label="Reset Value"
              value={resetMeterValue}
              onChange={(e) => setResetMeterValue(e.target.value)}
              placeholder="Enter reset value"
              inputProps={{ min: 0, step: "any" }}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1.5,
                  fontSize: "14px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "14px",
                },
              }}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 1.5,
                pt: 1,
              }}
            >
              <Button
                variant="outlined"
                size="medium"
                onClick={() => {
                  setOpenResetMeterDialog(false);
                  setLoading(false);
                }}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  borderRadius: 1.5,
                  px: 2.5,
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                size="medium"
                onClick={() => {
                  console.log(resetMeterValue,resetSubmitStatusValues)
                  if(resetMeterValue>0) {
                    
                    resetSubmitStatusValues.meterResetValue = resetMeterValue;
                    saveStatus(resetSubmitStatusValues);
                  }else{
                    toast.error("Reset value must be greater than 0.");
                    return;
                  }
                }}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 1.5,
                  px: 2.5,
                  boxShadow: "none",
                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
              >
                Submit
              </Button>
            </Box>
          </Paper>
        }
      />
    </Box>
  );
};

export default ChangeStatusWO;
